import React from 'react'

const Footer = () => {
    return (
        <footer>
            <p className="copy">Developed with love by <a href="https://nessierdg.netlify.app/" rel="noreferrer" target="_blank">Lucio Nessier</a> © . See <a href="https://github.com/lucionessier" target="_blank" rel="noreferrer">full repo</a>. </p>
        </footer>
    )
}

export default Footer
